<script setup lang="ts">
  import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
  import Input from "~/components/ui/input/Input.vue";
  import CountrySelect from "~/components/ui/country-selectbox/CountrySelect.vue";
  import { ref, computed, watch, reactive, onMounted } from 'vue'
  import useFormValidation from "~/utils/validators";
  import {DESKTOP, ERROR_MESSAGE_PHONE} from "~/constant/common";
  import { assetCDN, getCountryName, getCountryPhone, isDeepEqual, isEmpty } from '~/helper'
  import FooterSteps from "~/components/pages/Enquiry/MultiStepsForm/Steps/FooterSteps.vue";
  import Carousel from '~/components/ui/carousel/Carousel.vue'
  import CarouselNav from '~/components/ui/carousel/Pagination.vue'
  import Slide from '~/components/ui/carousel/Slide.vue'
  import parsePhoneNumber from 'libphonenumber-js'
  import { getCookie } from '~/mixins/cookie'
  import countryList from '~/components/ui/country-selectbox/country.json'
  import { EnquiryStepEnum, keyLocalStorage } from '~/enum/enquiry'
  import { useRoute } from 'vue-router'
  import { gtmTracking } from '~/mixins/gtm'
  import { useEnquiryCaptureStore } from '~/store/pinia/enquiryCapture'
  import { useGeneralInfoStore } from '~/store/pinia/generalInfo'
  const {isChrome, isEdge, isFirefox, isSafari} = useDevice()

  const countries = ref(countryList)

  const css = {
    slide: {
      info: 'absolute bottom-0 left-0 z-3 wp-100 hp-100 bg-gray-50 br-10 flex justify-end flex-column black tl px-10 py-16',
      title: 'fs-16 lh-24 fw-700 wp-100 pb-5',
      desc: 'fs-14 fw-400 lh-20',
    },
  }
  const props = defineProps({
    // labelClass: { type: Object, default: () => {} },
    // heightForm: { type: Number },
    // stepActive: { type: String, default: EnquiryStepEnum.Information }
    formData: { type: Object, default: () => {} }
  })

  const emits = defineEmits(['nextStep', 'prevStep'])
  
  const firstIndex = 0
  const disableEmail = ref(false)
  const phoneMsg = ref('')
  const error = ref('')
  // const modalActiveHIW = ref(false)
  const disableSubmitButton = ref(false)
  const ASSETS_CDN = assetCDN()
  const enquiryID = ref(null)
  // const preEmail = ref('')

  const enquiryCaptureStore = useEnquiryCaptureStore()
  const route = useRoute()
  const generalStore = useGeneralInfoStore()

  // const keyLocalStorage = {
  //   enquiry: 'enquiry_capture',
  //   enquiryId: 'enquiry_capture_id',
  // }

  const dataStep = reactive({
    email: '',
    phone: '',
    contactName: '',
    nationality: '',
    check_newsletter: 1
  })

  const mobileBanner = ref([
    {
      title: 'Travel with confidence',
      desc: "Rated <span class='fw-700'>9.4/10</span> by past travellers.",
    },
    {
      title: 'Book with confidence',
      desc: "<span class='fw-700'>1,900+ travellers</span> have booked a trip with us.",
    },
    {
      title: 'Unparalleled Travel Insights',
      desc: "Backed by a network of <span class='fw-700'>270+ local designers.</span>",
    },
  ])

  const { validateNameField, validateEmailField, validatePhoneNumberField, errors } = useFormValidation()

  const windowWidth = computed(() => generalStore.generalData.windowWidth)
  const isDesktop = computed(() => windowWidth.value > DESKTOP)
  const arrayStepEnquiry = computed(() => enquiryCaptureStore.arrayStep)
  const enquiryOptionData = computed(() => enquiryCaptureStore.enquiryOptionData)
  const galleryData = computed(() => enquiryCaptureStore.galleryData)
  const stepOld = computed(() => enquiryCaptureStore.stepsData)
  const stepBefore = computed( () => {
    if(stepOld.value &&
      stepOld.value[(route.path).toString()] &&
      stepOld.value[(route.path).toString()][EnquiryStepEnum.Information])
      return stepOld.value[(route.path).toString()][EnquiryStepEnum.Information]
    return {}
  })
  const currentStep = computed(() => {
    if (stepOld.value && stepOld.value[route.path.toString()]) return stepOld.value[route.path.toString()].step
    return arrayStepEnquiry.value[firstIndex]
  })
  const indexCurrentStep = computed(() => arrayStepEnquiry.value.indexOf(EnquiryStepEnum.Information) + 1)
  // const verifyEmailWait = ref(false)

  const deviceInfo = () => {
    if(isChrome) return "Chrome"
    if(isEdge) return "Edge"
    if(isFirefox) return "Firefox"
    if(isSafari) return "Safari"
    return ""
  }

  /*const handleVerifyEmail = async (status) => {
    disableSubmitButton.value = true
    if (isEmpty(dataStep.email)) {
      validateEmailField('email', dataStep.email, 'auth')
    } else {
      verifyEmailWait.value = !status

      if(preEmail.value !== dataStep.email) {
        const res = await store.dispatch('authStore/verifyEmail',
        {
          email: dataStep.email,
          source: 'enquiry_multiStep'
        })
        if(res.error !== 0) {
          errors.email = res.message
        } else {
          errors.email = ''
        }
      }
      verifyEmailWait.value = false
    }
    disableSubmitButton.value = false
  }

  const handleDisableFields = () => {
    preEmail.value = dataStep.email
  }*/
  const nextStep = async () => {
    validateNameField('contact_name', dataStep.contactName)
    validateEmailField('email', dataStep.email, 'auth')
    validateInputPhone(dataStep.phone, dataStep.nationality)
    // await handleVerifyEmail('next')

    if(!errors.email && !errors.contact_name && !phoneMsg.value) {
      disableSubmitButton.value = true
      let code = dataStep.nationality || getCookie('country_code=')
      let dial_code = getCountryPhone(code)

      const GTMTrackingSubmit = gtmTracking()

      let payload  = {
        path: (route.path).toString(),
        enquiry_id: enquiryID.value,
        step: EnquiryStepEnum.Information,
        [EnquiryStepEnum.Information]: {
          email: dataStep.email,
          phone: dataStep.phone ? dial_code.concat(dataStep.phone) : '',
          contact_name: dataStep.contactName,
          check_newsletter: 1
        },
        [EnquiryStepEnum.YourStyle]:
        stepOld.value && stepOld.value[route.path] && stepOld.value[route.path][EnquiryStepEnum.YourStyle]
          ? {
              suggestion: stepOld.value[route.path][EnquiryStepEnum.YourStyle].suggestion,
            }
          : undefined,
        req_source: {
          is_public: 1,
          expert_id: route.name === 'enquiry-submit-ld' ? enquiryOptionData.value.designer?.id : 0,
          feature_region_id: galleryData.value?.feature_region_id ? galleryData.value?.feature_region_id : undefined,
          feature_region_name: galleryData.value?.feature_region_name ? galleryData.value?.feature_region_name : undefined,
          // sketch_country: getCookie('country_code'),
          sketch_country: enquiryOptionData.value?.country_code || '',
          sketch_feature_region: '',
          sketch_group: '',
          sketch_trip_id: ['enquiry-submit-trip', 'trip-plan'].includes(route.name as string)  ? enquiryOptionData.value?.trip_id : '',
          sketch_source: route.path,
          affiliate_id: route.name === 'withintrepid' ? useAppConfig().intrepidID : undefined
        },
        geo_loc: {
          device: null,
          device_name: deviceInfo() || null,
          country_code: getCookie('country_code') || '',
          country_name: getCookie('country_name') || '',
          city_name: getCookie('city_name') || '',
          ip_address: window.client_addr || '',
          currency: getCookie('dj_curr') || null,
          timezone: getCookie('timezone') || '',
          browser_timezone: new Intl.DateTimeFormat().resolvedOptions().timeZone || '',
          region_name: getCookie('region_name') || '',
          phone_country: getCountryName(dataStep.nationality) || ''
        },
        contest_gtm: GTMTrackingSubmit || null,
      }

      const stepEdit = isDeepEqual(stepBefore.value,dataStep)

      if(!stepEdit) {
        disableSubmitButton.value = true
        const step = await enquiryCaptureStore.submitEnquiryCapture({ payload, dataStep })
        disableSubmitButton.value = false
        if(step?.status === 200) {
          debounceAmplitudeScriptTracking("View Enquiry (step 2)", {
            has_phone_number_warning: ((errors.phone === ERROR_MESSAGE_PHONE[0]) || (errors.phone === ERROR_MESSAGE_PHONE[1])) ? true : false
          });
          error.value = ''
          emits('nextStep')
        } else if(step?.error === 500) {
          if(step?.data?.error_fields) {
            errors.email = step?.data?.error_fields?.email || ''
          }
          else {
            error.value = step?.message || ''
            throw new Error(`submit enquiry step ${EnquiryStepEnum.Information} error:`, {
              cause: {
                data: step,
                payload,
              }
            })
          }
        }
      } else if(!error.value) {
        emits('nextStep')
      }
      disableSubmitButton.value = false
    }
  }

  const validateInputPhone = (phone, nationality) => {
    validatePhoneNumberField('phone', phone, nationality)
    if((errors.phone === ERROR_MESSAGE_PHONE[0]) ||
      (errors.phone === ERROR_MESSAGE_PHONE[1])) {
      phoneMsg.value = ''
    } else {
      phoneMsg.value = errors.phone
    }
  }

  watch(dataStep, (val) => {
    if (!isEmpty(val.email)) validateEmailField('email', val.email, 'auth')
    if (!isEmpty(val.contactName)) validateNameField('contact_name', val.contactName)
    if (!isEmpty(val.phone) && !isEmpty(val.nationality)) {
      validateInputPhone(val.phone, val.nationality)
    }
  })

  const setUserInfo = (data) => {
    dataStep.nationality = data?.nationality || getCookie('country_code')
    dataStep.email = data?.email || ''
    dataStep.phone = data?.phone || ''
    dataStep.contactName = data?.contactName || ''
  }

  onMounted(() => {
    // console.log('[galleryData.value]',enquiryOptionData.value?.country_code)
    const is_verified = getCookie('is_verified=')
    const userLogin = enquiryCaptureStore.userLoginData

    if(is_verified === '1' && !isEmpty(userLogin)) {
      disableEmail.value = true

      let userData = {
        nationality: null as string | null,
        phone: '',
        email: userLogin?.email,
        contactName: userLogin?.first_name + " " + userLogin?.last_name
      }

      let phone = userLogin?.phone ? parsePhoneNumber(userLogin.phone) : null

      if (phone && phone.countryCallingCode) {
        let ctr = countries.value.find(item => {
          return item.dial_code === phone.countryCallingCode
        })
        userData.nationality = ctr ? ctr.code : null
      }
      userData.phone = phone?.nationalNumber || userLogin?.phone
      setUserInfo(userData)

    } else {
      const enquiry = JSON.parse(localStorage.getItem(keyLocalStorage.enquiry)!)

      let enquiryMultiInfo = {}
      if(enquiry && enquiry[(route.path).toString()]) {
        enquiryID.value = enquiry[(route.path).toString()]?.enquiry_id
        const userInfo = enquiry[(route.path).toString()][EnquiryStepEnum.Information]
        enquiryMultiInfo = !isEmpty(userInfo) ? userInfo : enquiry?.user ? enquiry?.user[EnquiryStepEnum.Information] : {}
      } else {
        if(enquiry?.user) enquiryMultiInfo = enquiry?.user[EnquiryStepEnum.Information]
      }
      setUserInfo(enquiryMultiInfo)
    }
  })

</script>

<template>
  <div>
    <div class='px-24 mb-px-16 overflow-auto' :style='isDesktop || formData.isUIPopup ? `height: ${formData.heightForm}px` : ""'>
      <div :class='formData.labelClass?.stepsLabel'>Step {{ indexCurrentStep }} of 5</div>
      <div :class='formData.labelClass?.titleClass'>About you</div>
      <div :class='[formData.labelClass?.subTitleClass, formData.labelClass?.divider]'>So we can reach you to discuss your trip and the estimated price.</div>
      <div class="pt-16">
        <div class="relative">
          <div class="content-form">
            <label :class="formData.labelClass?.cssLabelField" ref='contactNameRef'>Your Name</label>
            <div :class='formData.labelClass?.sectionForm'>
              <Input
                type="text"
                placeholder="Eg: John Smith"
                name="contact_name"
                id="contact_name"
                v-model="dataStep.contactName"
              ></Input>
              <div class="error-message" v-if="errors.contact_name">This is a required field.</div>
            </div>
            <label :class="formData.labelClass?.cssLabelField" ref='contactEmailRef'>Email Address</label>
            <div :class="['relative', formData.labelClass?.sectionForm]">
              <Input
                type="email"
                name="email"
                placeholder="smith@gmail.com"
                id="email"
                :disabled="disableEmail"
                v-model="dataStep.email"
                autocomplete="email"
                :isCard="true"
                icon="email"
              >
<!--                <template #loading>-->
<!--                  <div class='absolute left-16 w-14 h-14' style='top: 13px'>
                    <img :src="`${ASSETS_CDN}/images/enquiryB2C/icon-envelope.png`" alt='Envelope'/>
                  </div>-->
<!--                  <span class="absolute right-0 top-0 w-36 h-40" v-if="verifyEmailWait">
                    <span class='spinner-outer'>
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </span>
                  </span>-->
<!--                </template>-->
              </Input>
              <div class="error-message" v-if="errors.email">
                {{ errors.email }}
              </div>
            </div>
            <label :class="formData.labelClass?.cssLabelField" ref='contactPhoneRef'>Phone Number</label>
            <div :class='formData.labelClass?.sectionForm'>
              <CountrySelect
                typeCountry="text"
                placeholderCountry="Country"
                placeholderPhone="Phone"
                :valueDataCountry="dataStep.nationality"
                v-model:country="dataStep.nationality"
                v-model:phone="dataStep.phone"
              />
              <div :class="[phoneMsg ? 'error-message' : 'warning-message']" v-if="errors.phone">
                {{ errors.phone }}
              </div>
            </div>

            <div v-if="error" class='pb-30 red error-bottom'>{{ error }}</div>
          </div>
        </div>
      </div>
      <Carousel v-if="!isDesktop && currentStep === EnquiryStepEnum.Information" class="h-100 wp-100 mt-16 mb-16" :wrap-around="true" :autoplay="6000" :pauseAutoplayOnHover="true">
        <template #counter>
          <img
            alt="bg_carousel_mb"
            class="img-cover absolute left-0 z-4 bd-1 bd-gray-medium br-10"
            style="object-position: 0 0"
            :src="`${ASSETS_CDN}/images/enquiryB2C/bg_carousel_mb.png`"
          />
        </template>
        <Slide v-for="(item, index) in mobileBanner" :key="index" class="wp-100 h-100">
          <div :class="css.slide.info">
            <div :class="css.slide.title">{{ item.title }}</div>
            <div :class="css.slide.desc" v-html="item.desc" />
          </div>
        </Slide>
        <template #addons>
          <CarouselNav class="about-you"/>
        </template>
      </Carousel>
    </div>
    <FooterSteps :disableSubmitButton='disableSubmitButton'
                 :labelClass='formData.labelClass'
                 :stepActive='EnquiryStepEnum.Information'
                 :isUIPopup='formData.isUIPopup'
                 :button-id="`enquiry-form-button-continue-step${indexCurrentStep}`"
                 @nextStep="nextStep"
                 @prevStep="$emit('prevStep')"/>
  </div>
</template>

<style scoped lang="scss">
  :deep(.carousel__pagination.about-you) {
    position: absolute;
    top: 20px;
    width: 60%;
    padding: 0px 10px;
    display: grid;
    grid-column-gap: 2px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    .carousel__pagination-button {
      background-color: rgba(255, 255, 255, 0.55);
      display: block;
      font-size: 0;
      line-height: 0;
      height: 1px;
      &.carousel__pagination-button--active {
        background-color: brandColor(brand, 800);
    }
  }
}
</style>
